import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Section,
  SectionDetails,
  SectionSeparator,
  SectionSummary,
  SectionSummaryDescription,
  SectionSummaryTitle,
} from './styles';
import TextArea from '../../../shared/text-area';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import { usePostUpdateInvestmentPhilosophy } from '../../../../services/profiles/contributor-settings-service';

export default function InvestmentPhilosophy({ investmentPhilosophy, onUpdate }) {
  const [changingIndex, setChangingIndex] = React.useState(-1);
  const [points, setPoints] = React.useState(investmentPhilosophy);
  const [{ loading, error }, post] = usePostUpdateInvestmentPhilosophy();

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error saving investment philosophy');
  }, [error]);

  const handlePointChange = index => v => {
    setChangingIndex(index);
    const newPoints = [...points];
    newPoints[index] = v;
    setPoints(newPoints);
    post(newPoints).then(() => onUpdate({ investmentPhilosophy: newPoints }));
  };

  const taProps = i => ({
    limit: 280,
    value: investmentPhilosophy[i] || '',
    label: `Point ${i + 1}`,
    onChange: handlePointChange(i),
    isLoading: loading && (changingIndex === i),
  });

  return (
    <>
      <SectionSeparator />
      <Section className="form-group">
        <SectionSummary>
          <SectionSummaryTitle>Your Investment Philosophy</SectionSummaryTitle>
          <SectionSummaryDescription>
            Provide up to 3 key summary sentences that give an outline to your
            strategy and philosophy regarding your fund, your analysis or research.
          </SectionSummaryDescription>
        </SectionSummary>
        <SectionDetails className="sip-controls">
          {_.times(3).map(index => <TextArea key={`point-${index + 1}`} {...taProps(index)} />)}
        </SectionDetails>
      </Section>
    </>
  );
}

InvestmentPhilosophy.propTypes = {
  investmentPhilosophy: PropTypes.arrayOf(PropTypes.string).isRequired,
  onUpdate: PropTypes.func,
};

InvestmentPhilosophy.defaultProps = { onUpdate: () => null };
